// Typelizer digest a85c1d92820bf45c2d85f1c4b4544fb1
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** PATCH /c/:company_id/payments/:payment_id/reference_document */
  update: (
    params: { paymentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/payments/:payment_id/reference_document', params, options),
    method: 'patch',
  }),
}
